// check for ie

if (window.document.documentMode) {
    console.log('internet explorer :(');

    if (window.location.href.toString().indexOf('/en/') >= 0) {
        window.location.href = 'https://scientifica.ch/en/browser-warning/';
    } else {
        window.location.href = 'https://scientifica.ch/browser-warnung/';
    }
}